<template>
    <AppHead title="My Benefits" />
    <div class="px-4 md:px-8">
        <CardBenefits></CardBenefits>
    </div>
</template>

<script setup>
import AppHead from '@/Partials/AppHead.vue';
import CardBenefits from '@/components/card-benefits/card-benefits.vue';
</script>
